import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.orangish,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.orangish,
  iconBorderColor: colors.orangish,
  iconBorderHoverColor: colors.orangish
};
export default socialIcon;